import React, {useContext, useState} from 'react';

import Row from "react-bootstrap/Row";
import {Table} from "react-bootstrap";
import {useIntl} from "react-intl";

import {Context} from "../index";

import DepotItemCont from "./UI/DepotItemCont";




const DepotListCont = (props) => {
    const {store} = useContext(Context);
    const intl = useIntl();



    return (
        <>

            <Row>

            </Row>
            <Table striped bordered hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Наименование</th>
                    <th>Артикул</th>
                    <th>Серийный номер</th>

                    <th>Повреждения</th>
                    <th>Уценка</th>
                    <th>Фото</th>
                </tr>

                </thead>
                <tbody>


                {props.depotList.map((depot, index) =>

                    <DepotItemCont key={index} num={index} depot={depot}  />

                )}


                <tr>
                    <td></td>
                    <td><strong>Итого:</strong></td>
                    <td><strong>{props.totalItem}</strong></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                </tbody>
            </Table>

        </>


    );
};

export default DepotListCont;
